import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root' 
})
export class TableDefaultService {
  private _statusBooleano = new BehaviorSubject<boolean>(false);

  public statusBooleano$: Observable<boolean> = this._statusBooleano.asObservable();

  enviarStatus(novoStatus: boolean) {
    this._statusBooleano.next(novoStatus);
  }
  
}